import { View } from 'react-native';
import { coinDotStyles as styles } from './CoinDot.styles';

/** Small amber coin marker used next to reward amounts. */
export function CoinDot() {
  return <View style={styles.coinDot} />;
}
